import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		...shorthands.padding(tokens.spacingVerticalL, tokens.spacingVerticalL),
	},
});
